var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"container",staticClass:"legend-container"},[_c('svg',{ref:"svg",staticClass:"overflow-visible fill-current"})])}
var staticRenderFns = []

export { render, staticRenderFns }